import React from 'react';
import styled from 'styled-components';
import useWindowResize from '../../../hooks/useWindowResize';

const ProviderFormBoxWrapper = styled.div<{ windowHeight: number; primaryColor?: string }>`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ primaryColor }) => primaryColor || 'var(--white)'};
  @media (max-width: 1200px) {
    max-height: ${({ windowHeight }) => windowHeight}px;
    width: 100%;
    gap: 0;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const ProviderFormWrapper = ({ children, primaryColor }: { children: React.ReactNode; primaryColor?: string }) => {
  const windowSize = useWindowResize();
  return (
    <ProviderFormBoxWrapper windowHeight={windowSize.height} primaryColor={primaryColor}>
      {children}
    </ProviderFormBoxWrapper>
  );
};

export const ProviderFormBox = styled.div<{ primaryColor?: string }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 713px;
  height: 100%;
  border-radius: 15px;
  background-color: ${({ primaryColor }) => primaryColor || 'var(--white)'};

  @media (max-width: 1200px) {
    flex: 1;
    width: 100vw;
    border-radius: 0;
  }
`;
